import React, { useState, useEffect } from 'react';
import { Home, Search, ShoppingBag, Grid, Heart } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
import './BottomNav.css';

const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState('HOME');

  const NAV_ITEMS = [
    { id: 'HOME', icon: Home, label: 'HOME', route: '/' },
    { id: 'SEARCH', icon: Search, label: 'SEARCH', route: '#search' },
    { id: 'SHOP', icon: ShoppingBag, label: 'SHOP', route: '/shop' },
    { id: 'COLLECTIONS', icon: Grid, label: 'COLLECTIONS', route: '/collections' },
    { id: 'WISHLIST', icon: Heart, label: 'WISHLIST', route: '/wishlist' },
  ];

  useEffect(() => {
    const currentPath = location.pathname;
    const active = NAV_ITEMS.find(item => item.route === currentPath);
    if (active) setActiveTab(active.id);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return (
    <div className="bottom-nav-wrapper">
      <div className="bottom-nav-container">
        <div className="bottom-nav-glass">
          {/* Moving Indicator Bubble */}
          <div 
            className="nav-indicator" 
            style={{ 
              transform: `translateX(calc(${NAV_ITEMS.findIndex(i => i.id === activeTab)} * 100%))` 
            }}
          >
            <div className="indicator-bubble">
              <div className="bubble-inner" />
            </div>
          </div>

          {NAV_ITEMS.map((item) => {
            const Icon = item.icon;
            const isActive = activeTab === item.id;
            
            return (
              <button 
                key={item.id}
                className={`bottom-nav-item ${isActive ? 'active' : ''}`}
                onClick={(e) => {
                  if (item.id === 'SEARCH') {
                    e.stopPropagation(); // Prevent document-level click listeners from closing it immediately
                    setActiveTab('SEARCH');
                    window.dispatchEvent(new CustomEvent('openSearchOverlay'));
                  } else {
                    setActiveTab(item.id);
                    navigate(item.route);
                  }
                }}
              >
                <div className="nav-icon-wrap">
                  <Icon size={22} strokeWidth={isActive ? 2 : 1.5} />
                </div>
                <span className="nav-label">{item.label}</span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default BottomNav;
